<template>
  <div>

    <keep-alive>
      <router-view></router-view>
    </keep-alive>

    <v-dialog v-model="loading" persistent width="300">
      <v-progress-linear indeterminate class="ma-0" />
    </v-dialog>

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapState([
      'loading',
    ]),
  },
  async mounted() {
    try {
      await this.initOptions();
    } catch (e) {
      console.log(e);
    } finally {
      this.setLoading(false);
    }
  },
  methods: {
    ...mapMutations([
      'setLoading',
    ]),
    ...mapActions([
      'initOptions',
    ]),
  },
}
</script>

